import { Container, Grid, useTheme, Typography, Box } from "@mui/material";
import React, { useEffect } from "react";
import Layout from "src/components/core/Layout";
import TargetOrdersComponent from "src/components/trade/target-orders/TargetOrdersComponent";
import Title from "src/components/common/Title";
import TargetOrderDataTable from "src/components/trade/target-orders/tables /TargetOrderDataTable";
import TargetOrderDataTableMobile from "src/components/trade/target-orders/tables /TargetOrderDataTableMobile";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { useAppDispatch } from "src/store/store";
import {
  resetForm,
  setTargetOrderType,
  setTargetPrice,
  setTargetTradeAmount,
} from "src/store/features/TargetOrders.slice";
import { trackEvent } from "src/Amplitude";
import { useMaintenanceState } from "src/store/features/maintenance.slice";
import MaintenanceBlock from "src/components/maintenance/MaintenanceBlock";
import CryptoRiskWarning from "src/components/disclosures/CryptoRiskWarning";

export const TargetOrders = () => {
  const { targetorderscontroller } = useMaintenanceState();

  const title = {
    partA: `Target Orders with`,
    partB: "caleb & brown",
  } as const;
  const isMobile = useIsMobile();
  const theme = useTheme();
  const dispatch = useAppDispatch();

  useEffect(() => {
    trackEvent("Visit_Page", { page: "Target_Order" });
    dispatch(setTargetOrderType());
    dispatch(resetForm());
    return () => {
      dispatch(setTargetTradeAmount(""));
      dispatch(setTargetPrice(""));
    };
  }, []);

  return (
    <Layout>
      {!targetorderscontroller && <MaintenanceBlock page={"Target Orders"} />}
      <Container
        sx={{
          marginBottom: "20px",

          [theme.breakpoints.down("sm")]: {
            padding: "5px",
          },
        }}>
        <Grid
          container
          spacing={2}
          mb={3}
          sx={{
            [theme.breakpoints.down(1366)]: {
              padding: "0px 100px",
            },
            [theme.breakpoints.down("sm")]: {
              paddingRight: "10px",
              paddingLeft: "10px",
            },
          }}>
          <Title title={title} />
          <Typography
            sx={{
              ml: 2.5,
              [theme.breakpoints.down("sm")]: {},
            }}>
            Set Targets & your broker will monitor these for you.
          </Typography>
        </Grid>

        {/* UK-only high-risk warning */}
        <CryptoRiskWarning />

        <Box
          display="grid"
          sx={{
            gridTemplateColumns: "repeat(12, 1fr)",
            [theme.breakpoints.down(1366)]: {
              gridTemplateColumns: "repeat(2, 1fr)",
              padding: "0px 100px",
            },
            [theme.breakpoints.down("sm")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
              padding: "0px",
            },
          }}
          gap={2}>
          <Box
            sx={{
              gridColumn: "span 4",
              [theme.breakpoints.down(1366)]: {
                gridColumn: "span 8",
              },
            }}>
            <TargetOrdersComponent />
          </Box>

          <Box
            gridColumn="span 8"
            sx={{
              [theme.breakpoints.down(1366)]: {
                gridColumn: "span 8",
              },
              [theme.breakpoints.down("sm")]: {
                gridTemplateColumns: "repeat(2, 1fr)",
                padding: "0px",
              },
            }}>
            {isMobile ? <TargetOrderDataTableMobile /> : <TargetOrderDataTable />}
            {/* </Paper> */}
          </Box>
        </Box>
      </Container>
    </Layout>
  );
};
